export default "__VITE_ASSET__DsVzQ4i6__"